import React, { useEffect, useState } from 'react'
import { useActionsInventoryArticles, useInventoryArticles } from '../../../context/inventory/InventoryArticlesByWarehouseProvider';
import { useAuth } from '../../../context/security/AuthProvider';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { LineTitle } from '../article';
import { customStyles } from '../test';
import Select from "react-select";
import axios from "../../../api/axios";
import { showTypeErrorFetch } from "../../../utilities/alerts.utilities";
import { InventoryByWarehouseTab } from './form/InventoryByWarehouseTab';
import { InventoryDetailByWarehouseTab } from './form/InventoryDetailByWarehouseTab';


export const InventoryArticlesByWarouseIndex = () => {

  const stateAuth = useAuth();
  const state = useInventoryArticles();
  const actions = useActionsInventoryArticles();

  const { warehouses } = stateAuth.user;
  const { selected_warehouses, articles } = state;
  const filter = articles.filter;

  const [measures, setMeasures] = useState([]);
  const [nameDraft, setNameDraft] = useState("");
  const [referenceDraft, setReferenceDraft] = useState("");

  useEffect(() => {
    axios()
      .get("inventory/getMeasures")
      .then(({ data }) => setMeasures(Array.isArray(data) ? data : []))
      .catch((e) => showTypeErrorFetch(e));
  }, []);

  useEffect(() => {
    setNameDraft(filter.name ?? "");
    setReferenceDraft(filter.reference ?? "");
  }, [filter.name, filter.reference]);

  const selectedMainMeasure = filter.equivalent_measure_id
    ? measures.filter((m) => m.id === filter.equivalent_measure_id)
    : null;

    console.log(selectedMainMeasure);
    console.log(filter.equivalent_measure_id);
    console.log(measures);
    
    

  return (
    <section className="container-fluid">
      <LineTitle title={"Inventario en almacenes"} />


      <section className=" form-create-article">
        <div className="row">
        <div className="form-group col-md-4 col-lg-4">
          <label className="control-label">Almacén</label>
            <Select
              isMulti
              value={selected_warehouses}
              placeholder="Selecciona uno o más almacenes"
              getOptionLabel={(option) => (option.code ? option.code + " - " + option.name : option.name)}
              getOptionValue={(option) => option.id}
              options={warehouses || []}
              styles={customStyles}
              onChange={(selected) => actions.setFieldWarehouse(selected || [])}
            />
          </div>
          <div className="form-group col-md-3 col-lg-3">
            <label className="control-label">Artículo</label>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre del artículo"
              value={nameDraft}
              onChange={(e) => setNameDraft(e.target.value)}
              onBlur={() =>
                actions.setWarehouseInventoryFilters({
                  name: nameDraft.trim() ? nameDraft.trim() : null,
                })
              }
            />
          </div>
          <div className="form-group col-md-2 col-lg-2">
            <label className="control-label">Código</label>
            <input
              type="text"
              className="form-control"
              placeholder="Código"
              value={referenceDraft}
              onChange={(e) => setReferenceDraft(e.target.value)}
              onBlur={() =>
                actions.setWarehouseInventoryFilters({
                  reference: referenceDraft.trim() ? referenceDraft.trim() : null,
                })
              }
            />
          </div>
          <div className="form-group col-md-3 col-lg-3">
            <label className="control-label">Und. medida principal</label>
            <Select
              isClearable
              placeholder="Todas"
              value={selectedMainMeasure}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              options={measures}
              styles={customStyles}
              onChange={(opt) =>
                actions.setWarehouseInventoryFilters({
                  equivalent_measure_id: opt ? opt.id : null,
                })
              }
            />
          </div>

        </div>

        
      </section>
      {selected_warehouses.length > 0 && (
        <Tabs default={true} defaultIndex={0} >
          <TabList>
            <Tab>Inventarios</Tab>
            <Tab>Detalle inventario</Tab>
          </TabList>


          <TabPanel>
            <InventoryByWarehouseTab />
          </TabPanel>
          <TabPanel>
            <InventoryDetailByWarehouseTab />
          </TabPanel>
        </Tabs>
      )}
    </section>
  );
}

